import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc8be39a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "添加配置", -1 /* HOISTED */))
const _hoisted_3 = { class: "dialog-content" }
const _hoisted_4 = { class: "select-content" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": $props.addVisible,
    width: "500",
    "show-close": false,
    "destroy-on-close": "",
    "before-close": $setup.handleClose
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_icon, {
          size: "18",
          style: {"cursor":"pointer"},
          onClick: $setup.handleClose
        }, {
          default: _withCtx(() => [
            _createVNode($setup["CloseBold"])
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, { onClick: $setup.handleClose }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: $setup.submit
        }, {
          default: _withCtx(() => [
            _createTextVNode("确认")
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_select, {
            modelValue: $setup.configType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.configType) = $event)),
            placeholder: "选择配置类型",
            style: {"width":"240px"},
            onChange: $setup.handleConfigTypeChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from($setup.CONFIG_TYPES), ([key, value]) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: value,
                  value: key
                }, null, 8 /* PROPS */, ["label", "value"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]),
          _createVNode(_component_el_select, {
            modelValue: $setup.pushType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.pushType) = $event)),
            placeholder: "选择推送类型",
            disabled: $setup.configType === '',
            style: {"width":"240px"},
            onChange: $setup.handlePushTypeChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pushTypeList, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.label,
                  label: item.label,
                  value: item.value
                }, null, 8 /* PROPS */, ["label", "value"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue", "disabled"])
        ]),
        ($setup.pushType)
          ? (_openBlock(), _createBlock(_component_el_card, {
              key: 0,
              shadow: "never",
              style: {"width":"460px"}
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, _toDisplayString($setup.PUSH_TYPE_MAP[$setup.pushType]), 1 /* TEXT */)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  ref: "formRef",
                  model: $setup.formData,
                  "label-width": "120px"
                }, {
                  default: _withCtx(() => [
                    _createCommentVNode(" 动态表单渲染 "),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentFormConfig, (field) => {
                      return (_openBlock(), _createBlock(_component_el_form_item, {
                        key: field.label,
                        label: field.label,
                        prop: field.model,
                        rules: field.ruler
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: $setup.formData[field.model],
                            "onUpdate:modelValue": ($event: any) => (($setup.formData[field.model]) = $event),
                            placeholder: field.placeholder,
                            onBlur: ($event: any) => ($setup.onInputBlur(field.model))
                          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "placeholder", "onBlur"])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "prop", "rules"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["model"])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["model-value"]))
}